import { PAGE_PDP_CONFIG } from '@storefront/utils/constants';

export const UDL_PAGE_NAME: { [key: string]: string } = {
  [PAGE_PDP_CONFIG]: 'pdp-config',

  UNDEFINED: 'undefined-page-name',
};
